module.exports = __webpack_public_path__ + "static/anshul-118aa98cc16d42a621d2397d5a7d27ee.jpg";